import { Button, soundManager, SoundType, t } from '@slot-nx/core'
import { TextStyle } from 'pixi.js'
import { Container, Text } from '@pixi/react'
import { SpinType, useBetDetailStore } from '../../../domain/betDetail/store/betDetailStore'
import { GameDetail } from '../../../domain/betDetail/models/BetDetailResponse'

const whiteStyle = new TextStyle({ fontSize: 46, fontWeight: 'bold', fill: '#FFFFFF' })
const grayStyle = new TextStyle({ fontSize: 46, fontWeight: 'bold', fill: '#606061' })

interface SwitchSpinTypeTabProps {
  spinType: SpinType
  gameDetail: GameDetail
  currentIndex: number
  isFromOpBetDetail: boolean
}

export const SwitchSpinTypeTab = (props: SwitchSpinTypeTabProps) => {
  const hasFreeGame = props.gameDetail.fgDropList.length > 0
  const mgGameDetail = props.gameDetail.mgDropList[props.currentIndex]
  const fgGameDetail = props.gameDetail.fgDropList[props.currentIndex]
  const [setCurrentMgIndex, setCurrentFgIndex] = useBetDetailStore(x => [x.setCurrentMgIndex, x.setCurrentFgIndex])
  let freeGameRound = '0'
  const changeFontSize = (info: string, textLength: number) => {
    return info.length > textLength
  }
  if (hasFreeGame) {
    if (props.spinType === SpinType.BonusSpin) {
      freeGameRound = `${fgGameDetail.round + 1}-${fgGameDetail.dropIndex + 1}`
    }
    else {
      freeGameRound = '1-1'
    }
  }

  const mainSpinTabPress = () => {
    if (!props.isFromOpBetDetail) {
      soundManager.play(SoundType.buttonConfirm)
    }
    setCurrentFgIndex(0)
    useBetDetailStore.setState({ selectSpinType: SpinType.MainSpin })
  }

  const freeSpinTabPress = () => {
    setCurrentMgIndex(0)
    soundManager.play(SoundType.buttonConfirm)
    useBetDetailStore.setState({ selectSpinType: SpinType.BonusSpin })
    if (!props.isFromOpBetDetail) {
      soundManager.play(SoundType.buttonConfirm)
    }
  }

  return (
    <Container name="SwitchSpinTypeTab">
      <Button
        name="MainSpinTab"
        x={80}
        y={235}
        width={450}
        height={80}
        onPress={mainSpinTabPress}
        defaultView="round_tab_disabled2"
        disabledView="round_tab_normal2"
        pressedView="round_tab_disabled2"
        enabled={props.spinType !== SpinType.MainSpin}
      />
      <Text
        name="main_spin_tab"
        text={t('betDetail_detail_tab_main_spin')}
        x={249}
        y={275}
        anchor={[0.5, 0.5]}
        style={new TextStyle({
          fill: '#FFFFFF',
          fontSize: changeFontSize(t('betDetail_detail_tab_main_spin'), 10) ? 35 : 46,
          fontWeight: 'bold',
        })}
      />
      <Text
        name="main_spin_tab_number"
        text={props.spinType === SpinType.MainSpin && mgGameDetail ? `${mgGameDetail.round + 1}-${mgGameDetail.dropIndex + 1}` : '1-1'}
        x={460}
        y={275}
        anchor={[0.5, 0.5]}
        style={whiteStyle}
      />

      <Button
        name="BonusSpinTab"
        x={570}
        y={240}
        width={450}
        height={80}
        onPress={freeSpinTabPress}
        defaultView="round_tab_disabled2"
        disabledView={hasFreeGame ? 'round_tab_normal2' : 'round_tab_disabled2'}
        pressedView="round_tab_disabled2"
        enabled={props.spinType !== SpinType.BonusSpin && hasFreeGame}

      />
      <Text
        name="bonus_spin_tab"
        text={t('betDetail_detail_tab_bonus_spin')}
        x={745}
        y={280}
        anchor={[0.5, 0.5]}
        style={new TextStyle({
          fill: hasFreeGame ? '#FFFFFF' : '606061',
          fontSize: changeFontSize(t('betDetail_detail_tab_bonus_spin'), 10) ? 35 : 46,
          fontWeight: 'bold',
        })}
      />
      <Text
        name="main_spin_tab_number"
        text={freeGameRound}
        x={955}
        y={280}
        anchor={[0.5, 0.5]}
        style={hasFreeGame ? whiteStyle : grayStyle}
      />
    </Container>
  )
}
